import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-ai-generator-button',
  templateUrl: './ai-generator-button.component.html',
  styleUrls: ['./ai-generator-button.component.css'],
  imports: [NgClass, MatProgressSpinner],
})
export class AIGeneratorButtonComponent {
  @Input() isButtonEnabled = false;
  @Input() isLoading = false;
  @Input() buttonText = '';
  @Input() isSmall = false;

  @Output() buttonClick = new EventEmitter<void>();

  onClick() {
    this.buttonClick.emit();
  }
}
